import React from "react";

import {
  Dimensions,
  Weight,
  Distance,
  Title,
  hasDimensions,
} from "shared/components";
import { Spacer } from "shared/layout";
import { IDimensions } from "Venues/types";
import { copy } from "shared/assets";
import { Icon, MutedDarkText } from "shared/styles";
import {
  Dimensions as DimensionsIcon,
  Weight as WeightIcon,
} from "shared/assets/icons";

const { dimensions: dimensionsCopy } = copy.stageProperties;

interface StageDimensionProps {
  dimensions?: {
    room?: IDimensions;
    stage?: IDimensions;
  };
  distanceFromLoadingToStage?: number;
  stageWeightPerSquareMeter?: number;
}

export const StageDimensions: React.FC<StageDimensionProps> = ({
  dimensions,
  distanceFromLoadingToStage,
  stageWeightPerSquareMeter,
}) => {
  const renderText = (icon: React.ComponentType<any>, text: string) => (
    <MutedDarkText>
      <Spacer size="xs" spaceDirection="horizontal" align="center">
        <Icon as={icon} />
        <span>{text}</span>
      </Spacer>
    </MutedDarkText>
  );

  return (
    <Spacer size="m">
      <Title asComponent="h3" size="s" title={dimensionsCopy.title} />
      <Spacer size="xs">
        {hasDimensions(dimensions?.room) && (
          <Spacer size="xs" spaceDirection="horizontal" align="center">
            {renderText(
              DimensionsIcon,
              dimensionsCopy.properties.roomDimensions
            )}
            <Dimensions dimensions={dimensions?.room} />
          </Spacer>
        )}
        {hasDimensions(dimensions?.stage) && (
          <Spacer size="xs" spaceDirection="horizontal" align="center">
            {renderText(
              DimensionsIcon,
              dimensionsCopy.properties.stageDimensions
            )}
            <Dimensions dimensions={dimensions?.stage} />
          </Spacer>
        )}
        {distanceFromLoadingToStage !== undefined && (
          <Spacer size="xs" spaceDirection="horizontal">
            {renderText(
              DimensionsIcon,
              dimensionsCopy.properties.distanceFromLoadingToStage
            )}
            <span>
              <Distance distance={distanceFromLoadingToStage} />
            </span>
          </Spacer>
        )}
        {stageWeightPerSquareMeter !== undefined && (
          <Spacer size="xs" spaceDirection="horizontal">
            {renderText(
              WeightIcon,
              dimensionsCopy.properties.stageWeightPerSquareMeter.basic
            )}
            <span>
              <Weight weight={stageWeightPerSquareMeter} />
            </span>
          </Spacer>
        )}
      </Spacer>
    </Spacer>
  );
};
